import { HEADER_VERSIONS, ZHL_NAVBAR_BREAKPOINTS_IN_PX, ZILLOW_NAVBAR_BREAKPOINTS_IN_PX } from '../constants';

type NavbarBreakpoints = {
    DESKTOP: number;
    MOBILE: number;
};

export const getBreakpointsForHeaderVersion = (version: HEADER_VERSIONS): NavbarBreakpoints => {
    switch (version) {
        case HEADER_VERSIONS.ZHL_DEFAULT: {
            return ZHL_NAVBAR_BREAKPOINTS_IN_PX;
        }
        case HEADER_VERSIONS.DEFAULT:
        case HEADER_VERSIONS.TRANSPARENT_MOBILE_ONLY:
        case HEADER_VERSIONS.SEARCH_MOBILE_ONLY: {
            return ZILLOW_NAVBAR_BREAKPOINTS_IN_PX;
        }
    }
};
